import SidebarComponent from "../../components/Sidebar";
import NavbarComponent from "../../components/Navbar";
import React, { Component } from "react";
import Pagination from "react-js-pagination";
import { Modal } from "react-bootstrap";
import { alert, POST, PUT, DELETE, tokens, role, format_date, number } from "../../components/CustomComponent.js";
import "../../assets/css/bootstrap.css";
export default class CommissionTypeScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,

      loading: false,
      modal_add: false,
      modal_edit: false,
      modal_delete: false,

      data: null,

      commission_type_name: "",
      commission_cal: "",
      commission_unit: "",
      id: "",
      search: "",
    };
  }
  async componentDidMount() {
    await this.GetAll();
  }
  GetAll = async () => {
    this.setState({ loading: true });
    let body = {
      data_search: this.state.search,
    };
    let result = await POST(tokens, "v1/commission-mgt/search/page/" + this.state.page, body);

    if (result && result.status) {
      this.setState({ data: result.data });
    }
    this.setState({ loading: false });
  };
  AddTypeCommission = async () => {
    this.setState({ loading: true });
    let body = {
      commission_type_name: this.state.commission_type_name,
      commission_cal: this.state.commission_cal,
      commission_unit: this.state.commission_unit,
    };
    let result = await POST(tokens, "v1/commission-mgt/create", body);

    if (result && result.status) {
      alert("success", "เพิ่มประเภทค่าคอมมิชชันเรียบร้อยแล้ว", "ค่าคอมมิสชัน ' " + this.state.commission_type_name + " ' ถูกเพิ่มในระบบแล้ว");
      this.setState({ loading: false, modal_add: false });
      this.ClearForm();
      this.GetAll();
    }
    this.setState({ loading: false });
  };
  EditTypeCommission = async () => {
    this.setState({ loading: true });
    let body = {
      commission_type_id: this.state.id,
      commission_type_name: this.state.commission_type_name,
      commission_cal: this.state.commission_cal,
      commission_unit: this.state.commission_unit,
    };
    let result = await PUT(tokens, "v1/commission-mgt/update", body);

    if (result && result.status) {
      alert("success", "แก้ไขประเภทค่าคอมมิชชันเรียบร้อยแล้ว", "ค่าคอมมิสชัน ' " + this.state.commission_type_name + " ' ถูกแก้ไขข้อมูลในระบบแล้ว");
      this.setState({ loading: false, modal_edit: false });
      this.ClearForm();
      this.GetAll();
    }
    this.setState({ loading: false });
  };
  Delete = async (id) => {
    this.setState({ loading: true });
    let result = await DELETE(tokens, "v1/commission-mgt/delete/" + id, null);
    if (result && result.status) {
      alert("success", "ลบข้อมูลประเภทค่าคอมมิชชันเรียบร้อยแล้ว", "ประเภทค่าคอมมิชชัน ' " + this.state.commission_type_name + " ' ถูกลบข้อมูลในระบบแล้ว");
      this.setState({ loading: false, modal_delete: false });
      this.ClearForm();
      this.GetAll();
    }
    this.setState({ loading: false });
  };
  HandlePageChange(pageNumber) {
    this.setState({ page: pageNumber });
    setTimeout(() => {
      this.GetAll();
    }, 10);
  }

  ClearForm() {
    this.setState({
      page: 1,

      commission_type_name: "",
      commission_cal: "",
      commission_unit: "",

      id: "",
    });
  }
  render() {
    return (
      <div className="full bg-contain w-100">
        {this.state.loading && (
          <div className="spinner-container">
            <div className="loading-spinner"></div>
          </div>
        )}
        <div className="menu-container">
          <SidebarComponent />
          <div className="bodyw-100">
            <NavbarComponent page1="หน้าหลัก" page2="ประเภทค่าคอมมิชชัน" />
            <div style={{ height: 60 }}></div>
            <div className="w-100 row mx-0 d-flex align-items-center justify-content-between px-3 mt-3">
              <h3>
                <b>ประเภทค่าคอมมิชชัน</b>
              </h3>

              {role && role.type_commission[1] === 1 && (
                <div className="d-flex">
                  <button
                    type="button"
                    className="btn btn-primary w-100 px-4"
                    onClick={() => {
                      this.setState({ modal_add: true });
                    }}
                  >
                    {" "}
                    เพิ่มประเภทค่าคอมฯ{" "}
                  </button>
                </div>
              )}
            </div>
            <div className="w-100 p-3">
              <div className="card">
                <div className="card-header row d-flex mx-0 px-2 rounded-top-16">
                  <div className="col-6 col-sm-6 col-xl-3 d-flex">
                    <div className="w-100">
                      <input
                        maxLength={30}
                        type="search"
                        className="form-control-search"
                        placeholder="พิมพ์คำค้นหา"
                        value={this.state.search}
                        onChange={(e) => {
                          this.setState({ page: 1, search: e.target.value, loading: false });
                          if (e.target.value === "") {
                            this.setState({ search: "" });
                            setTimeout(() => {
                              this.GetAll();
                              this.setState({ loading: false });
                            }, 20);
                          } else {
                            setTimeout(() => {
                              this.GetAll();
                              this.setState({ loading: false });
                            }, 20);
                          }
                        }}
                      ></input>
                    </div>
                  </div>
                </div>
                <div className="card-body p-0 ">
                  <div className="table-responsive rounded-16">
                    <table className="table table-striped table-borderless table-sm table-hover">
                      <thead>
                        <tr>
                          <th className="text-left" style={{ minWidth: 150 }}>
                            <b>วันที่สร้าง</b>
                          </th>
                          <th className="text-left" style={{ minWidth: 110 }}>
                            <b>ชื่อประเภท</b>
                          </th>
                          <th className="text-center" style={{ minWidth: 100 }}>
                            <b>ค่าคอมมิสชัน</b>
                          </th>
                          <th className="text-center">
                            <b>หน่วย</b>
                          </th>
                          {role && (role.type_commission[2] === 1 || role) && role.type_commission[3] === 1 && (
                            <th className="text-center" style={{ minWidth: 120 }}>
                              <b>จัดการ</b>
                            </th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {((this.state.data && this.state.data.count === 0) || !this.state.data) && (
                          <tr>
                            <td colSpan={5} className="text-center table-light">
                              -- ไม่มีข้อมูล --
                            </td>
                          </tr>
                        )}

                        {this.state.data &&
                          this.state.data.data.map((item, index) => (
                            <tr key={index} className="pointer">
                              <td className="text-left">{format_date(item.datetime_create)}</td>
                              <td className="text-left">{item.commission_type_name}</td>
                              <td className="text-center">{item.commission_cal}</td>
                              <td className="text-center">{item.commission_unit}</td>
                              <td className="text-center">
                                {role && role.type_commission[2] === 1 && (
                                  <button
                                    className="btn btn-link text-secondary"
                                    onClick={() => {
                                      this.setState({
                                        commission_type_name: item.commission_type_name,
                                        commission_cal: item.commission_cal,
                                        commission_unit: item.commission_unit,
                                        id: item.commission_type_id,
                                        modal_edit: true,
                                      });
                                    }}
                                  >
                                    <label className="icon mr-2 pointer">{"\uf040"}</label>
                                  </button>
                                )}

                                {role && role.type_commission[3] === 1 && (
                                  <button
                                    className="btn btn-link text-secondary"
                                    onClick={() => {
                                      this.setState({
                                        commission_type_name: item.commission_type_name,
                                        id: item.commission_type_id,
                                        modal_delete: true,
                                      });
                                    }}
                                  >
                                    <label className="icon mr-2 pointer">{"\uf2ed"}</label>
                                  </button>
                                )}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              {/* pagination */}
              {this.state.data && this.state.data.data.length !== 0 && (
                <div className="row w-100 justify-content-between mx-0  my-4">
                  <div className="col-12 col-sm-6 col-md-6 col-xl-6 d-flex">
                    <div className="d-flex w-100 justify-content-xl-start justify-content-md-start justify-content-sm-start">
                      <label>
                        {" "}
                        แสดง {number(this.state.data.end_index)} รายการจาก {number(this.state.data.count)} รายการ{" "}
                      </label>
                    </div>
                  </div>
                  <div className="col-12 col-sm-6 col-md-6 col-xl-6 d-flex ">
                    <div className="d-flex w-100 justify-content-xl-end justify-content-md-end justify-content-sm-end">
                      <button
                        className="btn-circle-white mx-1 pointer"
                        onClick={() => {
                          this.HandlePageChange(1);
                        }}
                      >
                        {" "}
                        <label className="icon pointer">{"\uf100"}</label>{" "}
                      </button>
                      <Pagination activePage={this.state.page} itemsCountPerPage={10} totalItemsCount={this.state.data.count} pageRangeDisplayed={5} onChange={this.HandlePageChange.bind(this)} prevPageText={<label className="icon pointer">{"\uf104"}</label>} nextPageText={<label className="icon pointer">{"\uf105"}</label>} hideFirstLastPages={true} />
                      <button
                        className="btn-circle-white mx-1 pointer"
                        onClick={() => {
                          this.HandlePageChange(this.state.data.page_number);
                        }}
                      >
                        <label className="icon pointer">{"\uf101"}</label>
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* เพิ่มประเภทค่าคอมมิสชัน */}
        <Modal
          show={this.state.modal_add}
          size="m"
          onHide={() => {
            this.setState({ modal_add: false });
            this.ClearForm();
          }}
        >
          <Modal.Header>
            <Modal.Title>
              <b className=" text-18">เพิ่มประเภทค่าคอมมิสชัน</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* ชื่อประเภท */}
            <div className="w-100 d-flex mb-3">
              <div className="wpx-120">
                <label>ชื่อประเภท:</label>
              </div>
              <div className="w-100">
                <input
                  maxLength={30}
                  className="form-control bg-secondary-light border-0"
                  type="text"
                  placeholder="กรอกข้อมูล"
                  onChange={(e) => {
                    this.setState({ commission_type_name: e.target.value });
                  }}
                  value={this.state.commission_type_name}
                />
              </div>
            </div>
            {/* ค่าคอมมิชชัน */}
            <div className="w-100 d-flex mb-3">
              <div className="wpx-120">
                <label>ค่าคอมมิชชัน:</label>
              </div>
              <div className="w-100">
                <input
                  maxLength={10}
                  className="form-control bg-secondary-light border-0"
                  type="text"
                  placeholder="กรอกข้อมูล"
                  onChange={(e) => {
                    let commission_cal = this.state.commission_cal;
                    commission_cal = e.target.value.replace(/\D/g, "");
                    this.setState({
                      commission_cal: commission_cal,
                    });
                  }}
                  value={this.state.commission_cal}
                />
              </div>
            </div>
            {/* หน่วย */}
            <div className="w-100 d-flex mb-3">
              <div className="wpx-120">
                <label>หน่วย:</label>
              </div>
              <div className="w-100">
                <select
                  className="form-control bg-secondary-light border-0"
                  onChange={(e) => {
                    this.setState({ commission_unit: e.target.value });
                  }}
                  value={this.state.commission_unit}
                >
                  <option value="" selected disabled>
                    -- เลือก --
                  </option>
                  <option value="percent">% (เปอร์เซ็น)</option>
                  <option value="baht">฿ (บาท)</option>
                </select>
              </div>
            </div>

            <div className="w-100 d-flex">
              <div className="w-50 p-1">
                <button
                  className="btn btn-outline-primary w-100"
                  onClick={() => {
                    this.setState({ modal_add: false });
                    this.ClearForm();
                  }}
                >
                  {" "}
                  ยกเลิก{" "}
                </button>
              </div>
              <div className="w-50 p-1">
                <button
                  className="btn btn-primary w-100"
                  onClick={() => {
                    if (this.state.commission_type_name === "") {
                      alert("warning", "แจ้งเตือน", "กรุณากรอกชื่อประเภท");
                      return;
                    } else if (this.state.commission_cal === "") {
                      alert("warning", "แจ้งเตือน", "กรุณากรอกค่าคอมมิชชัน");
                      return;
                    } else if (this.state.commission_unit === "") {
                      alert("warning", "แจ้งเตือน", "กรุณากรอกหน่วย");
                      return;
                    }

                    this.AddTypeCommission();
                  }}
                >
                  {" "}
                  เพิ่ม{" "}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* แก้ไขประเภทค่าคอมมิชชัน */}
        <Modal
          show={this.state.modal_edit}
          size="m"
          onHide={() => {
            this.setState({ modal_edit: false });
            this.ClearForm();
          }}
        >
          <Modal.Header>
            <Modal.Title>
              <b className="text-18">แก้ไขประเภทค่าคอมมิชชัน</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* ชื่อประเภท */}
            <div className="w-100 d-flex mb-3">
              <div className="wpx-120">
                <label>ชื่อประเภท:</label>
              </div>
              <div className="w-100">
                <input
                  maxLength={30}
                  className="form-control bg-secondary-light border-0"
                  type="text"
                  placeholder="กรอกข้อมูล"
                  onChange={(e) => {
                    this.setState({ commission_type_name: e.target.value });
                  }}
                  value={this.state.commission_type_name}
                />
              </div>
            </div>
            {/* ค่าคอมมิชชัน */}
            <div className="w-100 d-flex mb-3">
              <div className="wpx-120">
                <label>ค่าคอมมิชชัน:</label>
              </div>
              <div className="w-100">
                <input
                  maxLength={10}
                  className="form-control bg-secondary-light border-0"
                  type="text"
                  placeholder="กรอกข้อมูล"
                  onChange={(e) => {
                    let commission_cal = this.state.commission_cal;
                    commission_cal = e.target.value.replace(/\D/g, "");
                    this.setState({
                      commission_cal: commission_cal,
                    });
                  }}
                  value={this.state.commission_cal}
                />
              </div>
            </div>
            {/* หน่วย */}
            <div className="w-100 d-flex mb-3">
              <div className="wpx-120">
                <label>หน่วย:</label>
              </div>
              <div className="w-100">
                <select
                  className="form-control bg-secondary-light border-0"
                  onChange={(e) => {
                    this.setState({ commission_unit: e.target.value });
                  }}
                  value={this.state.commission_unit}
                >
                  <option value="" selected disabled>
                    -- เลือก --
                  </option>
                  <option value="percent">% (เปอร์เซ็น)</option>
                  <option value="baht">฿ (บาท)</option>
                </select>
              </div>
            </div>

            <div className="w-100 d-flex">
              <div className="w-50 p-1">
                <button
                  className="btn btn-outline-primary w-100"
                  onClick={() => {
                    this.setState({ modal_edit: false });
                    this.ClearForm();
                  }}
                >
                  {" "}
                  ยกเลิก{" "}
                </button>
              </div>
              <div className="w-50 p-1">
                <button
                  className="btn btn-primary w-100"
                  onClick={() => {
                    if (this.state.commission_type_name === "") {
                      alert("warning", "แจ้งเตือน", "กรุณากรอกชื่อประเภท");
                      return;
                    } else if (this.state.commission_cal === "") {
                      alert("warning", "แจ้งเตือน", "กรุณากรอกค่าคอมมิชชัน");
                      return;
                    } else if (this.state.commission_unit === "") {
                      alert("warning", "แจ้งเตือน", "กรุณากรอกหน่วย");
                      return;
                    }

                    this.EditTypeCommission();
                  }}
                >
                  {" "}
                  บันทึก{" "}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* ลบประเภทค่าคอมมิชชัน */}
        <Modal
          show={this.state.modal_delete}
          size="m"
          onHide={() => {
            this.setState({ modal_delete: false });
          }}
        >
          <Modal.Header>
            <Modal.Title>
              <b className="text-18">ลบประเภทค่าคอมมิชชัน</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="w-100 row mx-0 d-flex mb-3">
              <div className="col-12 mb-3">ท่านแน่ใจว่าต้องการลบประเภทค่าคอมมิชชันนี้หรือไม่</div>
              <div className="col-12 mb-3">หมายเหตุ: ไม่สามารถย้อนคืนข้อมูลได้หลักจากลบ</div>
            </div>
            <div className="w-100 d-flex">
              <div className="w-50 p-1">
                <button
                  className="btn btn-danger w-100"
                  onClick={() => {
                    this.Delete(this.state.id);
                  }}
                >
                  {" "}
                  ลบถาวร{" "}
                </button>
              </div>
              <div className="w-50 p-1">
                <button
                  className="btn btn-outline-primary w-100"
                  onClick={() => {
                    this.setState({ modal_delete: false });
                  }}
                >
                  {" "}
                  ยกเลิก{" "}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
